import React from "react";
import { useTranslation } from "react-i18next";
import { Row, Col } from "antd";
// Styling
import { NumberBullet } from "./AfterSignUpStyle";

const AfterRegistrationStep4 = () => {
  const { t } = useTranslation("after_sign_up");

  return (
    <div className="block">
      <Row gutter={36} align="middle">
        <Col span={4}>
          <NumberBullet>
            <span>1</span>
          </NumberBullet>
        </Col>
        <Col span={20}>
          {t("Choose to book a Flexi Class or a Full Course.")}
        </Col>
      </Row>
      <p>
        <b>{t("Flexi Class:")}</b>
        {t(" Study whenever you want, teachers might change.")}
      </p>
      <p>
        <b>{t("Full Course")}:</b>
        {t(" Fixed Schedule with the same teacher")}.
      </p>
      <Row gutter={36} align="middle">
        <Col span={4}>
          <NumberBullet>
            <span>2</span>
          </NumberBullet>
        </Col>
        <Col span={20}>
          {t("Book any class/course in your level that fits your schedule.")}
        </Col>
      </Row>
      <p>{t("Do not worry which class, just try it.")} </p>
      <p>
        {t("For maximum choice, book")}
        <b> 48 {t("hours")}</b> {t("in advance")}.
      </p>
      <p>
        {t("Need Help? ")}
        <br />
        {t("Create a post on the ")}
        <b>
          <u>
            <a href="https://www.reddit.com/r/FlexiClasses/" target="_blank">
              {t("Flexi Forum")}
            </a>
          </u>
        </b>
        .
      </p>
    </div>
  );
};

export default AfterRegistrationStep4;
